"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CloseButton = void 0;
const React = require("react");
const Icon_1 = require("../../../../../../components/base/atoms/Icon");
const styles = require("./styles.scss");
const cssComposer_1 = require("../../../../../../helpers/cssComposer");
const css = (0, cssComposer_1.default)(styles, "CloseButton");
const CloseButton = ({ setOpen }) => (React.createElement("div", { "data-test": "close-button", className: css(""), onClick: () => {
        setOpen(false);
    } },
    React.createElement(Icon_1.Icon, { name: "close" })));
exports.CloseButton = CloseButton;
//# sourceMappingURL=index.js.map